import { ColDef, ColGroupDef, ValueFormatterParams } from '@ag-grid-community/core';

import { TableConstants } from '@shared/constants/table.constants';
import { Currency } from '@shared/services/gql.service';
import { AuxExcelStyleKeys } from '@shared/utils';
import { Utils } from '@shared/utils/utils';

import { AgHeaderCollapseColumnsActionComponent } from '../components/ag-header-collapse-columns-action/ag-header-collapse-columns-action.component';

// eslint-disable-next-line max-lines-per-function
export const InvestigatorSummaryColumns = (
  siteNumberColumnSettings: ColDef,
  columns: ColDef[]
): (ColDef | ColGroupDef)[] => [
  {
    children: [
      {
        cellClass: AuxExcelStyleKeys.TEXT_FORMAT,
        field: 'site_no',
        filter: true,
        headerName: 'Site #',
        hide: true,
        rowGroup: true,
      },
      siteNumberColumnSettings,
      {
        aggFunc: 'first',
        cellClass: [
          TableConstants.STYLE_CLASSES.CELL_ALIGN_LEFT,
          AuxExcelStyleKeys.TEXT_FORMAT,
          '!block',
        ],
        field: 'site_name',
        filter: true,
        headerName: 'Site Name',
        minWidth: 125,
        resizable: true,
        suppressSizeToFit: true,
        tooltipField: 'site_name',
        valueFormatter: (value: ValueFormatterParams) => value.value || Utils.zeroHyphen,
      },
      {
        aggFunc: 'first',
        cellClass: [
          TableConstants.STYLE_CLASSES.CELL_ALIGN_LEFT,
          AuxExcelStyleKeys.TEXT_FORMAT,
          '!block',
        ],
        field: 'investigator',
        filter: true,
        headerName: 'Primary Investigator',
        minWidth: 125,
        resizable: true,
        suppressSizeToFit: true,
        tooltipField: 'investigator',
        valueFormatter: (value: ValueFormatterParams) => value.value || Utils.zeroHyphen,
      },
      {
        cellClass: [TableConstants.STYLE_CLASSES.CELL_ALIGN_LEFT, AuxExcelStyleKeys.TEXT_FORMAT],
        field: 'patient',
        filter: true,
        headerName: 'Patient ID',
        minWidth: 125,
        resizable: true,
        suppressSizeToFit: true,
        tooltipField: 'patient',
        valueFormatter: (value: ValueFormatterParams) => value.value || Utils.zeroHyphen,
      },
    ],
    headerClass: 'ag-header-align-center',
    headerName: 'Patients & Sites',
  },
  TableConstants.SPACER_COLUMN,
  {
    children: [
      ...columns,
      {
        aggFunc: 'sum',
        cellClass: ['cell-right', 'cost', TableConstants.STYLE_CLASSES.CELL_ALIGN_RIGHT],
        field: 'patient_visit_total',
        headerComponent: AgHeaderCollapseColumnsActionComponent,
        headerName: 'Patient Visit Total',
        minWidth: 170,
        resizable: true,
        tooltipField: 'patient_visit_total',
        valueFormatter: (params: Pick<ValueFormatterParams, 'value'>) =>
          params.value ? Utils.agCurrencyFormatter(params, Currency.USD) : Utils.zeroHyphen,
      },
      {
        aggFunc: 'sum',
        cellClass: ['cell-right', 'cost', TableConstants.STYLE_CLASSES.CELL_ALIGN_RIGHT],
        field: 'invoiceables',
        headerName: 'Invoiceables',
        minWidth: 125,
        resizable: true,
        tooltipField: 'invoiceables',
        valueFormatter: (params: Pick<ValueFormatterParams, 'value'>) =>
          params.value ? Utils.agCurrencyFormatter(params, Currency.USD) : Utils.zeroHyphen,
      },
      {
        aggFunc: 'sum',
        cellClass: ['cell-right', 'cost', TableConstants.STYLE_CLASSES.CELL_ALIGN_RIGHT],
        field: 'total_cost_to_date',
        headerName: 'Total Cost to Date',
        minWidth: 125,
        resizable: true,
        tooltipField: 'total_cost_to_date',
        valueFormatter: (params: Pick<ValueFormatterParams, 'value'>) =>
          params.value ? Utils.agCurrencyFormatter(params, Currency.USD) : Utils.zeroHyphen,
      },
      {
        aggFunc: 'sum',
        cellClass: ['cell-right', 'cost', TableConstants.STYLE_CLASSES.CELL_ALIGN_RIGHT],
        field: 'forecast_cost_through_eot',
        headerName: 'Forecast Cost through EOT',
        minWidth: 125,
        resizable: true,
        tooltipField: 'forecast_cost_through_eot',
        valueFormatter: (params: Pick<ValueFormatterParams, 'value'>) =>
          params.value ? Utils.agCurrencyFormatter(params, Currency.USD) : Utils.zeroHyphen,
      },
      {
        aggFunc: 'sum',
        cellClass: ['cell-right', 'cost', TableConstants.STYLE_CLASSES.CELL_ALIGN_RIGHT],
        field: 'amount_remaining',
        headerName: 'Amount Remaining',
        minWidth: 125,
        resizable: true,
        tooltipField: 'amount_remaining',
        valueFormatter: (params: Pick<ValueFormatterParams, 'value'>) =>
          params.value ? Utils.agCurrencyFormatter(params, Currency.USD) : Utils.zeroHyphen,
      },
    ],
    headerClass: 'ag-header-align-center',
    headerName: 'Totals',
  },
];
